import * as Yup from 'yup';
import PropTypes from 'prop-types';
// import { useSnackbar } from 'notistack5';
// import { useNavigate } from 'react-router-dom';
// import { Form, FormikProvider, useFormik } from 'formik';
// import { Form, FormikProvider, useFormik } from 'formik';
// material
// import { LoadingButton } from '@material-ui/lab';
import { Stack, TextField, Typography, Button, Autocomplete } from '@material-ui/core';
import { RemoveCircleOutline } from '@material-ui/icons';

//

// ----------------------------------------------------------------------

AddExtraCampaignRule.propTypes = {
  data: PropTypes.object,
  handleDeleteRule: PropTypes.func,
  setRule: PropTypes.func,
  rules: PropTypes.array,
  errors: PropTypes.object,
  id: PropTypes.number
};

export default function AddExtraCampaignRule({ id, data, handleDeleteRule, setRule, rules, errors, editId }) {
  const handleValueChange = (id, index, val) => {
    // NewRuleSchema.isValid({});
    const tempRule = [...rules];
    tempRule[id] = {
      ...tempRule[id],
      [index]: val
    };
    setRule(tempRule);
  };

  const conditionOptions = ['Contain', 'Not Contain', 'Greater than', 'Less than', 'Equals', 'Not equals to'];

  return (
    <Stack spacing={2}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} justifyContent="flex-end">
        {data.id !== 0 && (
          <Typography
            variant="subtitle1"
            sx={{ width: '90%', display: 'flex', justifyContent: 'space-around', alignItems: 'center', mt: '14px' }}
          >
            {' '}
            OR Condition{' '}
          </Typography>
        )}
        <Button
          variant="text"
          startIcon={<RemoveCircleOutline />}
          onClick={() => {
            handleDeleteRule(data.id);
          }}
          title="Delete Rule"
          // sx={{ height: '3rem' }}
        />
      </Stack>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 1 }}>
        <TextField
          fullWidth
          label="Column"
          placeholder="Column"
          value={rules[id].column_name}
          // onChange={values.column}
          InputProps={{
            readOnly: true
          }}
          onChange={(e) => handleValueChange(id, 'column_name', e.target.value)}
          error={Boolean(errors?.rules && errors?.rules[id]?.column_name)}
          helperText={errors?.rules && errors?.rules[id]?.column_name}
        />
      </Stack>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
        <Autocomplete
          fullWidth
          options={conditionOptions}
          getOptionLabel={(option) => option}
          onChange={(e, value) => {
            handleValueChange(id, 'if_cell_value', value);
          }}
          // readOnly={!isEditable}
          value={rules[id].if_cell_value}
          renderInput={(params) => (
            <TextField
              {...params}
              InputProps={{
                readOnly: true
              }}
              label="Cell"
              margin="none"
            />
          )}
          error={Boolean(errors?.rules && errors?.rules[id]?.if_cell_value)}
          helperText={errors?.rules && errors?.rules[id]?.if_cell_value}
        />
        {/* <TextField
          fullWidth
          label="Cell"
          placeholder="Cell"
          value={rules[id].if_cell_value}
          onChange={(e) => handleValueChange(id, 'if_cell_value', e.target.value)}
          error={Boolean(errors?.rules && errors?.rules[id]?.if_cell_value)}
          helperText={errors?.rules && errors?.rules[id]?.if_cell_value}
        /> */}
        <TextField
          sx={{ width: '70%' }}
          placeholder="Enter Value"
          value={rules[id].value_or_text}
          onChange={(e) => handleValueChange(id, 'value_or_text', e.target.value)}
          error={Boolean(errors?.rules && errors?.rules[id]?.value_or_text)}
          helperText={errors?.rules && errors?.rules[id]?.value_or_text}
        />
      </Stack>
    </Stack>
  );
}
